module.exports = __webpack_public_path__ + "static/testimonialbg-406b88feb87c04d801b837b07c5a2e95.png";